**Omega** measures the risk-adjusted performance of the portfolio, represented
by the ratio of the sum of gains with respect to the sum of losses (sum of positive
daily returns divided by the negative sum of negative daily returns).
